import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { isMediumUI } from 'shared/app/lib/choose-ui-type';
import { MediumUISortableDevices } from './medium';
import { isPropsEqual } from 'console/shared/utils/memo';
import { SmallUISortableDevices } from './small';
export const SortableDevices = memo(function SortableDevices(props) {
    const { component, devices } = props;
    const Component = isMediumUI() ? MediumUISortableDevices : SmallUISortableDevices;
    return _jsx(Component, { devices: devices, component: component });
}, isPropsEqual);
